import React, { useState } from "react";
import { FiChevronRight, FiChevronDown } from "react-icons/fi";
import PropTypes from "prop-types";

const CollapsibleEvidenceRationale = ({ evidence, rationale }) => {
  const [expanded, setExpanded] = useState(false);

  const hasEvidence = evidence && String(evidence).trim().length > 0;
  const hasRationale = rationale && String(rationale).trim().length > 0;

  if (!hasEvidence && !hasRationale) {
    return null;
  }

  let label = "View ";
  if (hasEvidence && hasRationale) {
    label += "Evidence & Rationale";
  } else if (hasEvidence) {
    label += "Evidence";
  } else {
    label += "Rationale";
  }

  const toggle = () => setExpanded((prev) => !prev);

  const renderSection = (title, content) => (
    <>
      <div className="collapsible-details-section-title">{title}</div>
      <div
        className="collapsible-details-text"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </>
  );

  return (
    <div className="collapsible-details">
      <div className="collapsible-details-header" onClick={toggle}>
        {expanded ? <FiChevronDown /> : <FiChevronRight />} {label}
      </div>
      {expanded && (
        <div className="collapsible-details-content">
          {hasEvidence && renderSection("Evidence", evidence)}
          {hasRationale && renderSection("Rationale", rationale)}
        </div>
      )}
    </div>
  );
};

CollapsibleEvidenceRationale.propTypes = {
  evidence: PropTypes.string,
  rationale: PropTypes.string,
};

CollapsibleEvidenceRationale.defaultProps = {
  evidence: "",
  rationale: "",
};

export default CollapsibleEvidenceRationale;
